export const environment = {
  googleAnalyticsId: 'G-DNG7VDLQY5', // TODO: Change after all tests passed
  recaptcha: {
    siteKey: '6LfaSyYlAAAAAD3bUgwP4ejws4lPY5opGJiu8JiE'
  },
  production: true
};
